const info = {
  ZH: { //中文翻译
    exportVolume: '请输入预计车型出口量',
    analysisOfTotalExportVolume:'出口总量分析',
    vehicle:'辆',
    export:'导出',
    assembly:'总成零部件号',
    doesIt:'是否满足要求',
    inadequate:'不满足子节点',
    materialProportion:'物质比例%',
    SVHC:'物品中的SVHC%',
    dowe:'是否需要通报',
    risk:'风险性',
    automotiveRelevance:'汽车相关性',
    prompt:'提示',
    materialsClass: '材料分类',
    ELV:"ELV有害物质符合性",
    PolymeraLabelingCompliance:"聚合物标识符合性",
    chemicalAnalysis:'化学品法规符合性分析',
    chemical:'化学品法规符合性',
    PolymerLabelingCompliance:'聚合物标识符合性',
    Regulations:'法规&履责要求',
    substancesList:'物质清单',
    userDefinedRules:'自定义校验规则',
    editRule:'编辑规则',
    viewRule:'查看规则',
    formValid:'校验表单',
    totalEV:'总计出口量（kg）',
    dwnSVHC:'是否需要SVHC通报',
    partDeviation:'零件偏差',
    materialCode:'材料代号',
    substancesContainingSVHC:'含SVHC物质',
    substancesContainingGADSL:'含GADSL物质',
    receiveMdsPleaseSelect:"请选择已接收的Mds",

  },
  EN: { //英文翻译
    exportVolume: 'Please enter the estimated export volume of vehicle models',
    analysisOfTotalExportVolume:'Analysis of total export volume',
    vehicle:'Vehicle',
    export:'Export',
    assembly:'Assembly part number',
    doesIt:'Compliance',
    inadequate:'Inadequate child nodes',
    materialProportion:'Material proportion%',
    SVHC:'SVHC% in the substance',
    dowe:'Do we need to report it',
    risk:'Risk',
    automotiveRelevance:'Automotive relevance',
    prompt:'Warning',
    materialsClass: "Material classification",
    ELV:"ELV Hazardous substance compliance",
    PolymeraLabelingCompliance:"Polymer labeling compliance",
    chemicalAnalysis:'Chemical regulatory compliance analysis',
    chemical:'Chemical regulatory compliance',
    PolymerLabelingCompliance:'Polymer marking compliance',
    Regulations:'Regulations&Performance Requirements',
    substancesList:'Substances List',
    userDefinedRules:'User Defined Rules',
    editRule:'Edit Rule',
    viewRule:'View Rule',
    formValid:'MDS verification',
    totalEV:'Total export volume (kg)',
    dwnSVHC:'Do we need SVHC notification',
    partDeviation:'Part deviation',
    materialCode:'Material code',
    substancesContainingSVHC:'Substances containing SVHC',
    substancesContainingGADSL:'Substances containing GADSL',
    receiveMdsPleaseSelect:"Please select the received Mds",


  }
}
export default info //需要暴露出去
